// src/config.js
// جميع الروابط مبنية على البيئة:
//   .env.development → قيم بيئة التطوير (تُستخدم في npm start)
//   .env.production  → قيم بيئة الإنتاج   (تُستخدم في npm run build)
// القيم الافتراضية أدناه = الإنتاج، كشبكة أمان لو لم تُمرَّر متغيرات البيئة.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://backend.fasterlink.me/api/v1';

export const END_USER_URL = (process.env.REACT_APP_END_USER_URL || 'https://fasterlink.me').replace(/\/+$/, '');
export const END_USER_HOST = END_USER_URL.replace(/^https?:\/\//, '');
export const BUSINESS_URL = (process.env.REACT_APP_BUSINESS_URL || 'https://business.fasterlink.me').replace(/\/+$/, '');

// حماية من نشر روابط التطوير على الإنتاج عند البناء
if (process.env.NODE_ENV === 'production') {
    const isDev = [BACKEND_URL, END_USER_URL, BUSINESS_URL].some((u) => u.includes('dev-') || u.includes('localhost'));
    if (isDev) {
        // eslint-disable-next-line no-console
        console.error('[config] ⚠️ تم بناء نسخة إنتاج بقيم بيئة تطوير:', { BACKEND_URL, END_USER_URL, BUSINESS_URL });
    }
}

export default BACKEND_URL;
